import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';

export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['infp'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'] }) {
    const { url } = data
    const time = Date.now()
    // 使用本地临时数据
    let armorToken = window?.localStorage?.getItem('armorToken') || ''
    window.__ArmorToken = armorToken
    window?.sessionStorage?.setItem('armorToken', armorToken)
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    })
        .then(() => {
            const armorToken = window?.AntiDevices?.getArmorToken()
            if (armorToken) {
                window.__ArmorToken = armorToken
                window?.sessionStorage?.setItem('armorToken', armorToken)
                window?.localStorage?.setItem('armorToken', armorToken)
                GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                    metric_name: METRIC_NAME,
                    tags: { url, type: 'loadInfp' },
                    value: Date.now() - time,
                    message: 'armorToken load success',
                })
            }
        }).then(() => {
            monitorSingleJsLoadTime('infp', JS_SERVER_TYPE[extra.env][extra.server_type]);
        })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadInfpError' },
                value: Date.now() - time,
                message: 'armorToken load error',
                params: error
            })
        })
}

export async function headerOpenController(self: XMLHttpRequest, url: string) {
    if (GlobalVariables.get(GLOBAL_VARIABLES.API_PATHS).some(path => url.includes(path))) {
        const at = window.__ArmorToken || window?.sessionStorage?.getItem('armorToken') || window?.localStorage?.getItem('armorToken') || ''
        self._customHeaders = {
            ...self._customHeaders,
            'armorToken': at
        };
    }
}

export async function headerSendController(self: XMLHttpRequest) {
    if (self?._customHeaders?.['armorToken']) {
        self.setRequestHeader('armorToken', self?._customHeaders?.['armorToken']);
    }
}

export async function provideArmorToken() {
    const time = Date.now();
    try {
        if (!window?.Wing) return ''
        const res = await window?.Wing?.postBridge('WingHeader/get') || {};
        const headers = res?.headers || {};
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadInfp', url: 'shein' },
            value: Date.now() - time,
            message: 'armorToken load success',
        })
        return headers['armorToken'] || ''
    } catch (error) {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadInfpError', url: 'shein' },
            value: Date.now() - time,
            message: 'armorToken load error',
            params: error
        })
    }
    return ''
}